export default __webpack_public_path__ + "static/media/hands-29.702d1749.png";